import React, { Component } from 'react';

import Select from '@lightspeed/cirrus-select';

import { createReactRenderer } from 'helpers/react-renderer';

const behaviourOptions = [
  { value: 'create_update', label: 'Create new Items & update Item data' },
  { value: 'update', label: 'Only update existing Items' },
  { value: 'create', label: 'Only create new Items' },
];

const matchOnOptions = [
  { value: 'systemSku', label: 'System ID (recommended)' },
  { value: 'upc', label: 'UPC' },
  { value: 'ean', label: 'EAN' },
  { value: 'customSku', label: 'Custom SKU' },
  { value: 'manufacturerSku', label: 'Manufacturer SKU' },
];

export default class ImportTypeSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedBehaviour: behaviourOptions[0],
      selectedMatchOn: matchOnOptions[0],
    };

    this.handleBehaviourChange = this.handleBehaviourChange.bind(this);
    this.handleMatchOnChange = this.handleMatchOnChange.bind(this);
  }

  handleBehaviourChange(event) {
    const { value } = event.currentTarget;
    const selectedBehaviour = behaviourOptions.find((option) => option.value === value);

    this.setState({ selectedBehaviour });
  }

  handleMatchOnChange(event) {
    const { value } = event.currentTarget;
    const selectedMatchOn = matchOnOptions.find((option) => option.value === value);

    this.setState({ selectedMatchOn });
  }

  render() {
    const { selectedBehaviour, selectedMatchOn } = this.state;
    const disableMatchOn = selectedBehaviour.value === 'create';
    const matchOnClass = disableMatchOn ? 'disabled' : null;
    return (
      <div className="dropdown-container">
        <div className="import-type-dropdown">
          <h3>Behavior</h3>
          <Select
            id="behaviour-dropdown"
            value={selectedBehaviour.value}
            onChange={this.handleBehaviourChange}
          >
            {behaviourOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
          <input type="hidden" name="behaviour-value" value={selectedBehaviour.value} />
        </div>
        <div className="import-type-dropdown">
          <h3 className={matchOnClass}>Match on Field</h3>
          <Select
            id="match-field-dropdown"
            value={selectedMatchOn.value}
            onChange={this.handleMatchOnChange}
            disabled={disableMatchOn}
          >
            {matchOnOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
          <input type="hidden" name="match-field-value" value={selectedMatchOn.value} />
        </div>
      </div>
    );
  }
}

const RenderedComponent = createReactRenderer({
  component: ImportTypeSelect,
  selector: '[data-react-root="import-type-select"]',
});

history.onChangeState(
  { name: 'item_import.views.item_import', tab: 'details' },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
